import { useState, useEffect } from "react";
import { Menu, X, Ticket } from "lucide-react";

const NAV_LINKS = [
  { id: "beranda", label: "BERANDA", href: "#beranda" },
  { id: "pertandingan", label: "PERTANDINGAN", href: "#pertandingan" },
  { id: "skuad", label: "SKUAD", href: "#skuad" },
  { id: "galeri", label: "GALERI", href: "#galeri" },
  { id: "berita", label: "BERITA", href: "#berita" },
  { id: "kontak", label: "KONTAK", href: "#kontak" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#050B14]/90 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#beranda" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="/30sff-logo.png"
            alt="The 30s FF"
            className="w-12 h-12 object-contain drop-shadow-[0_0_8px_rgba(230,57,70,0.5)]"
          />
          <div className="leading-none">
            <div className="font-display text-xl sm:text-2xl text-white tracking-wider">THE 30s FF</div>
            <div className="text-[10px] text-white/50 tracking-[0.2em]">OFFICIAL TEAM</div>
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={`nav-link-${link.id}`}
              className="text-sm font-semibold tracking-wider text-white/80 hover:text-[#E63946] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA + mobile toggle */}
        <div className="flex items-center gap-3">
          <a
            href="#kontak"
            data-testid="nav-cta-join"
            className="hidden sm:inline-flex items-center gap-2 bg-[#E63946] hover:bg-[#D62839] text-white px-5 py-2.5 text-sm font-bold tracking-wider transition-colors"
          >
            <Ticket size={16} /> GABUNG TIM
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden text-white p-2 hover:text-[#E63946] transition-colors"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-[#0A1128] border-t border-white/10">
          <div className="px-5 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                data-testid={`nav-mobile-link-${link.id}`}
                onClick={() => setOpen(false)}
                className="text-base font-semibold text-white/80 hover:text-[#E63946]"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
